import React from 'react';
import styles from './index.module.scss';

const IconArrow = ({ color = 'white' }) => {
    return (
        <svg className={styles.iconArrow} viewBox="0 0 11 18" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.414 0L0 1.414l7.293 7.293L0 16l1.414 1.414 8.708-8.707"
                fill={color}
                fillRule="evenodd"
            />
        </svg>
    );
};

export default IconArrow;
